import React, { useEffect, useState, useRef } from "react";
import CustomModal from "@/Shared/modal/CustomModal";
import { useForm, Controller } from "react-hook-form";
import toast from "react-hot-toast";
import CustomSelector from "@/Shared/input/CustomSelector";
import CustomToast from "@/Shared/Tosat/CustomToast";
import CustomErrorToast from "@/Shared/Tosat/CustomErrorToast";
import CustomInput from "@/Shared/input/CustomInput";
import CustomSelect from "@/Shared/input/CustomSelect";
import Select from "@/Shared/Select/index";
// import { addUser, updateUser, getUserPage } from "@/api/AdminUser";
import { isEmptyObject } from "@/utils/comFunction";
// import { deletUser } from "@/api/AdminUser";
import DeleteModal from "@/Shared/delete/DeleteModal";
import ls from "store2";
import { updateUserDetails, addNewUser, addNewEndUser } from "@/api/Users";
import PasswordInput from "@/Shared/input/PasswordInput";
const CreateAndEditUsers = ({
  isEditMode,
  modalOPen,
  setModalOpen,
  role = "",
  getlist,
  ownEdit,
  item = {},
  parentID,
  distributorId = "",
  changeParams = {},
  handleClose = () => {},
}) => {
  const loginRole = ls.get("user")["role"];
  // console.log(loginRole)
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: {
      firstName: item?.firstName,
      lastName: item?.lastName,
      businessEmail: item?.email,
      businessName: item?.businessName,
      businessAddress: item?.businessAdress,
      contactPerson: item?.contactPerson,
      contactNumber: item?.contactNumber,
      name: item?.name,
      last_name: item?.last_name,
      email: item?.email,
      country_id: item?.country_id,
      contact_number: item?.contact_number,
      contact_person: item?.contact_person,
      address: item?.address,
      office_id: item?.office_id,
      agent_id: item?.agent_id,
      distributor_id: item?.distributor_id,
      monitoring_station_id: item?.monitoring_station_id,
      installer_id: item?.installer_id,
      managerName: item?.managerName,
      parent_id: item?.parent_id,
    },
  });
  const watchedValue = watch("Nursing Home");
  const [title, setTitle] = useState("");
  const [isOwnEditModal, setIsOwnEditModal] = useState(false);
  const [okbtn, setOkbtn] = useState("");
  const [cstatus, setCstatus] = useState("create");
  const [NursingList, setNursingList] = useState([]);
  const [AgentIdUserList, setAgentIdUserList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [delRole, setDelRole] = useState("");
  const [parentId, setParentId] = useState("");
  const [mainRole, setMainRole] = useState(ls.get("mainRole"));
  const [resetTrigger, setResetTrigger] = useState(false);
  const childRef = useRef();
  const childRef1 = useRef();
  useEffect(() => {
    setIsOwnEditModal(ownEdit);
    if (modalOPen) {
      reset();

      // if (role == "End Users") {
      //   getnurStringUser();
      // }
      if (!isEmptyObject(item)) {
        setDelRole(item.role);
        const {
          firstName,
          lastName,
          businessEmail,
          businessName,
          businessAdress,
          contactPerson,
          contactNumber,

          //newPortal V1
          country_id,
          name,
          last_name,
          contact_number,
          contact_person,
          address,
          email,
          office_id,
          agent_id,
          distributor_id,
          monitoring_station_id,
          installer_id,
          id,
          managerName,
        } = item;
        setValue("firstName", firstName);
        setValue("lastName", lastName);
        setValue("businessEmail", businessEmail);
        setValue("businessName", businessName);
        setValue("businessAdress", businessAdress);
        setValue("contactPerson", contactPerson);
        setValue("contactNumber", contactNumber);

        //NewPortal V1
        setValue("name", name);
        setValue("last_name", last_name);
        setValue("email", email);
        setValue("country_id", country_id);
        setValue("contact_number", contact_number);
        setValue("address", address);
        setValue("office_id", office_id);
        setValue("agent_id", agent_id);
        setValue("distributor_id", distributor_id);
        setValue("monitoring_station_id", monitoring_station_id);
        setValue("installer_id", monitoring_station_id);
        setValue("contact_person", contact_person);
        setValue("managerName", managerName);
        setValue("id", id);
      } else {
        setCstatus("create");
      }
      if (!isOwnEditModal) {
        if (role == "Distributor") {
          if (isEmptyObject(item)) {
            setTitle("Create Distributor");
            setOkbtn("Create Distributor");
          } else {
            setTitle("Edit Distributor");
            setOkbtn("Save");
          }
        } else if (role == "nursing_home") {
          if (isEmptyObject(item)) {
            setTitle("Create Nursing Home");
            setOkbtn("Create Nursing Home");
          } else {
            setTitle("Edit Nursing Home");
            setOkbtn("Save");
          }
        } else if (role == "sales_agent") {
          if (isEmptyObject(item)) {
            setTitle("Create Sales Agent");
            setOkbtn("Create Sales Agent");
          } else {
            setTitle("Edit Sales Agent");
            setOkbtn("Save");
          }
        } else if (role == "End Users") {
          if (isEmptyObject(item)) {
            // childRef?.current?.rest();
            // childRef1?.current?.rest();
            setTitle("Create End Users");
            setOkbtn("Create End Users");
          } else {
            setTitle("Edit End Users");
            setOkbtn("Save");
          }
        } else if (role == "Super Admin") {
          if (isEmptyObject(item)) {
            setTitle("Create Super Admin");
            setOkbtn("Create Super Admin");
          } else {
            setTitle("Edit Super Admin");
            setOkbtn("Save");
          }
        } else if (role == "supports_agent") {
          if (isEmptyObject(item)) {
            setTitle("Create Support Agent");
            setOkbtn("Create Support Agent");
          } else {
            setTitle("Edit Support Agent");
            setOkbtn("Save");
          }
        } else if (role == "Elderly") {
          if (isEmptyObject(item)) {
            setTitle("Create Elderly");
            setOkbtn("Create Elderly");
          } else {
            setTitle("Edit Elderly");
            setOkbtn("Save");
          }
          //After New Portan
        } else if (role == "office") {
          if (isEmptyObject(item)) {
            setTitle("Create Office");
            setOkbtn("Create Office");
          } else {
            setTitle("Edit Office");
            setOkbtn("Save");
          }
        } else if (role == "nurse") {
          if (isEmptyObject(item)) {
            setTitle("Create Nurse");
            setOkbtn("Create Nurse");
          } else {
            setTitle("Edit Nurse");
            setOkbtn("Save");
          }
        } else if (role == "monitoring_station") {
          if (isEmptyObject(item)) {
            setTitle("Create Monitoring Station");
            setOkbtn("Create Monitoring Station");
          } else {
            setTitle("Edit Monitoring Station");
            setOkbtn("Save");
          }
        } else if (role == "installer") {
          if (isEmptyObject(item)) {
            setTitle("Create Installer");
            setOkbtn("Create Installer");
          } else {
            setTitle("Edit Installer");
            setOkbtn("Save");
          }
        } else if (role == "end_user") {
          if (isEmptyObject(item)) {
            setTitle("Create End User");
            setOkbtn("Create End User");
          } else {
            setTitle("Edit End User");
            setOkbtn("Save");
          }
        } else if (role == "super_admin") {
          if (isEmptyObject(item)) {
            setTitle("Create Super Admin");
            setOkbtn("Create Super Admin");
          } else {
            setTitle("Edit Super Admin");
            setOkbtn("Save");
          }
        } else if (role == "distributor") {
          if (isEmptyObject(item)) {
            setTitle("Create Distributor");
            setOkbtn("Create Distributor");
          } else {
            setTitle("Edit Distributor");
            setOkbtn("Save");
          }
        }
      } else {
        setTitle("Edit Profile");
        setOkbtn("Save");
      }
    }
  }, [modalOPen]);

  // useEffect(() => {
  //   const specificValue = getValues("Nursing Home");
  //   if (specificValue) {
  //     let row1 = NursingList.find((e) => e.label == specificValue);
  //     getsupportAgentIdUser(row1?.key);
  //   }
  // }, [watchedValue]);
  // const getQuest = (query) => {
  //   return new Promise((resolve, reject) => {
  //     getUserPage(query).then((data) => {
  //       let records = data.data.records;

  //       let list = records.map((e) => {
  //         return {
  //           key: e.id,
  //           label: e.firstName,
  //         };
  //       });

  //       resolve(list);
  //     });
  //   });
  // };

  const onSubmit = (data1) => {
    console.log(data1);
    const creatorID = ls.get("user")._id;
    const agent_id = ls.get("agent_id");
    const country_id = ls.session.get("country_id");
    const parent_id = ls.session.get("parent_id");
    // const monitoring_station_id = ls.session.get("monitoring_station_id");
    if (country_id) data1.country_id = country_id;
    if (parent_id) {
      data1.parent_id = parent_id;
      console.log("0");
    } else {
      console.log("100");
      data1.parent_id = creatorID;
    }
    // if (monitoring_station_id)
    //   data1.monitoring_station_id = monitoring_station_id;
    let changeParams1 = { ...changeParams };
    let data = { ...data1 };
    console.log(data);
    // Filter out fields based on role
    const roleFieldMapping = {
      office: [
        "name",
        "address",
        "email",
        "contact_number",
        "contact_person",
        "password",
        "parent_id",
      ],
      sales_agent: [
        "name",
        "last_name",
        "address",
        "email",
        "password",
        "contact_number",
        "parent_id",
      ],
      nursing_home: [
        "name",
        "address",
        "email",
        "password",
        "contact_person",
        "contact_number",
        "parent_id",
      ],
      monitoring_station: [
        "name",
        "address",
        "email",
        "password",
        "contact_number",
        "contact_person",
        "parent_id",
      ],
      installer: [
        "name",
        "last_name",
        "address",
        "email",
        "password",
        "contact_number",
        "parent_id",
      ],
      supports_agent: [
        "name",
        "last_name",
        "email",
        "password",
        "contact_number",
        "address",
        "parent_id",
      ],
      nurse: [
        "name",
        "last_name",
        "email",
        "address",
        "password",
        "contact_number",
        "parent_id",
      ],
      end_user: [
        "name",
        "last_name",
        "email",
        "address",
        "password",
        "contact_number",
        "agent_id",
        "country_id",
      ],
      distributor: [
        "name",
        "address",
        "email",
        "contact_number",
        "contact_person",
        "password",
      ],
      super_admin: [
        "name",
        "last_name",
        "email",
        "contact_number",
        "address",
        "password",
        "country_id",
      ],
    };

    const allowedFields = roleFieldMapping[role] || [];
    data = Object.fromEntries(
      Object.entries(data).filter(([key]) => allowedFields.includes(key))
    );
    if (!isEmptyObject(item)) {
      if (mainRole === "super_admin") {
        delete data["parent_id"];
      }
      if (mainRole === "super_admin" && role === "end_user") {
        delete data["agent_id"];
        delete data["country_id"];
      }
      if (mainRole == "office") {
        delete data["parent_id"];
      } else if (
        (mainRole == "distributor" && role === "sales_agent") ||
        role === "office"
      ) {
        delete data["parent_id"];
        delete data["parent_id"];
      } else if (
        mainRole === "sales_agent" ||
        mainRole === "monitoring_station"
      ) {
        delete data["parent_id"];
      } else if (mainRole === "nursing_home" && role === "nurse") {
        delete data["parent_id"];
      } else if (mainRole === "nurse" && role === "nurse") {
        delete data["parent_id"];
      }
      updateUserDetails(item?._id, { ...data })
        .then((res) => {
          toast.custom((t) => (
            <CustomToast t={t} text={"Modified successfully!"} />
            // <CustomToast t={t} text={res.message.charAt(0).toUpperCase() + res.message.slice(1)} />
          ));
          setModalOpen(false);
          getlist();
          reset();
          setResetTrigger(!resetTrigger);

          ls.session.set("country_id", null);
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (Object.keys(errors).length === 0) {
      if (
        mainRole === "sales_agent" &&
        (role !== "installer" || role !== "supports_agent")
      ) {
        if (role === "installer" || role === "supports_agent") {
          data.parent_id = parent_id;
          console.log("1");
        } else {
          data.parent_id = creatorID;
        }
      }
      if (
        mainRole === "distributor" ||
        (mainRole === "monitoring_station" && role !== "end_user") ||
        role === "nurse"
      ) {
        if (role === "nurse") {
          data.parent_id = parentID;
          console.log("2");
        } else if (role !== "sales_agent") {
          data.parent_id = creatorID;
          console.log("3");
        }
      } else if (mainRole === "super_admin" && role === "end_user") {
        data.agent_id = agent_id;
        console.log("4");
      }
      if (role !== "end_user") {
        addNewUser({ ...data, role })
          .then((res) => {
            console.log(res);
            toast.custom((t) => (
              <CustomToast t={t} text={"New User Created Successfully!"} />
            ));
            setModalOpen(false);
            getlist();
            reset();
            setResetTrigger(!resetTrigger);

            ls.session.set("country_id", null);
            ls.session.set("parent_id", null);
          })
          .catch((err) => {
            console.log(err);
            toast.custom((t) => (
              <CustomErrorToast
                t={t}
                title="Error"
                text={err.response.data.message}
              />
            ));
          });
      } else {
        addNewEndUser({
          ...data,
          ...changeParams1,
          customer_info: {
            installer_id,
          },
        })
          .then((res) => {
            console.log(res);
            toast.custom((t) => (
              <CustomToast t={t} text={"New User Created Successfully!"} />
            ));
            setModalOpen(false);
            getlist();
            reset();
            ls.session.set("country_id", null);
          })
          .catch((err) => {
            console.log(err);
            toast.custom((t) => (
              <CustomErrorToast
                t={t}
                title="Error"
                text={err.response.data.message}
              />
            ));
          });
      }
    } else {
      console.log("Validation errors:", errors);
    }
  };

  // const getsupportAgentIdUser = (id) => {
  //   getQuest({
  //     current: 1,
  //     size: 100,
  //     role: "Support Agent",
  //     nursingHomeId: id,
  //   }).then((data) => {
  //     setAgentIdUserList(data);
  //   });
  // };

  // const getnurStringUser = () => {
  //   getQuest({
  //     current: 1,
  //     size: 100,
  //     role: "Nursing Home",
  //   }).then((data) => {
  //     setNursingList(data);
  //   });
  // };
  const onModalClose = () => {
    console.log("onModalClose");
    reset();
    setResetTrigger(!resetTrigger);
  };
  const handalDelete = () => {
    setDeleteModal(false);
    // setModalOpen(false)
    deletUser({ id: item.id });

    setTimeout(() => {
      getlist();
      setModalOpen(false);
      toast.custom((t) => (
        <CustomToast t={t} text={`${role} has been successfully deleted`} />
      ));
      handleClose();
    }, 900);
  };
  const handalDelete1 = () => {
    setDeleteModal(true);
  };
  const getRoleLabel = (role) => {
    switch (role) {
      case "Distributor":
        return "Distributor";
      case "office":
        return "Office";
      case "monitoring_station":
        return "Monitoring Station";
      case "distributor":
        return "Distributor";
      case "nursing_home":
        return "Nursing Home";
      default:
        return "First";
    }
  };

  const getRoleMessage = (role) => {
    switch (role) {
      case "Distributor":
        return "distributor";
      case "office":
        return "office";
      default:
        return "nursing home";
    }
  };
  const fieldRoleMapping = {
    firstName: ["Super Admin", "Support Agent"],
    lastName: ["Super Admin", "Support Agent"],
    nursingHomeId: ["End Users", "Support Agent"],
    supportAgentId: ["End Users"],
    businessName: ["Distributor"],
    businessEmail: ["Distributor"],
    businessAddress: ["Distributor"],
    contactPerson: [
      "distributor",
      "Nursing Home",
      "Elderly",
      "office",
      "nursing_home",
      "monitoring_station",
    ],
    name: [
      "distributor",
      "super_admin",
      "nursing_home",
      "End Users",
      "Elderly",
      "office",
      "sales_agent",
      "monitoring_station",
      "installer",
      "supports_agent",
      "nurse",
      "end_user",
    ],
    last_name: [
      "super_admin",
      "sales_agent",
      "Support Agent",
      "installer",
      "supports_agent",
      "nurse",
      "end_user",
    ],
    email: [
      "distributor",
      "super_admin",
      "sales_agent",
      "Super Admin",
      "Support Agent",
      "nursing_home",
      "office",
      "monitoring_station",
      "installer",
      "supports_agent",
      "nurse",
      "end_user",
    ],
    phoneNumber: [
      "distributor",
      "super_admin",
      "office",
      "sales_agent",
      "nursing_home",
      "monitoring_station",
      "installer",
      "supports_agent",
      "nurse",
      "end_user",
    ],
    location: ["super_admin", "end_user"],
    selectOffice: ["sales_agent"],
    age: ["Elderly"],
    address: [
      "Nursing Home",
      "office",
      "sales_agent",
      "nursing_home",
      "monitoring_station",
      "installer",
      "end_user",
      "distributor",
      "nurse",
      "supports_agent",
      "super_admin",
    ],
    password: [
      "office",
      "sales_agent",
      "nursing_home",
      "monitoring_station",
      "installer",
      "supports_agent",
      "nurse",
      "end_user",
      "super_admin",
      "distributor",
    ],
    selectDistributor: ["office"],
    selectMonitoringStation: ["installer", "supports_agent"],
    selectAgent: ["end_user", "nursing_home", "monitoring_station"],
    selectInstaller: ["end_user"],
  };

  const renderCustomInput = (
    label,
    type,
    name,
    placeholder,
    registerOptions,
    errors
  ) => (
    <CustomInput
      label={label}
      type={type}
      register={register(name, registerOptions)}
      error={errors[name]}
      placeholder={placeholder}
    />
  );

  return (
    <CustomModal
      modalOPen={modalOPen}
      setModalOpen={setModalOpen}
      handleSubmit={handleSubmit(onSubmit)}
      handalDelete={handalDelete1}
      width={590}
      title={title}
      cstatus={cstatus}
      id={item?.id}
      buttonText={okbtn}
      onclose={onModalClose}
    >
      {/* <=================newPortal V1======================> */}

      {/* <=================All Type Of Name Feild=================> */}
      {/* <=================First Name Last name Feild=================> */}

      <div className="flex items-center gap-4">
        {fieldRoleMapping.name.includes(role) &&
          renderCustomInput(
            `${getRoleLabel(role)} Name`,
            "text",
            "name",
            `Enter ${getRoleLabel(role)} Name`,
            {
              required: {
                value: true,
                message: `Please enter ${getRoleLabel(role)} Name`,
              },
            },
            errors
          )}
        {fieldRoleMapping.last_name.includes(role) &&
          renderCustomInput(
            `Last Name`,
            "text",
            "last_name",
            `Enter Last Name`,
            {
              required: {
                value: true,
                message: `Please enter last Name`,
              },
            },
            errors
          )}
      </div>

      {/* <============Email Feild===============> */}
      {fieldRoleMapping.email.includes(role) && (
        <div>
          {renderCustomInput(
            "E-mail",
            "email",
            "email",
            "Enter E-Mail",
            {
              required: {
                value: true,
                message: "Please enter E-mail",
              },
            },
            errors
          )}
        </div>
      )}
      {/* <=================Phone Number Feild=================> */}
      {fieldRoleMapping.phoneNumber.includes(role) && (
        <>
          {renderCustomInput(
            "Contact Number",
            "text",
            "contact_number",
            "Enter Contact Number",
            {
              required: {
                value: true,
                message: "Please enter contact number",
              },
            },
            errors
          )}
        </>
      )}

      {/* <=================Contact Person Name=================> */}
      {fieldRoleMapping.contactPerson.includes(role) && (
        <>
          {renderCustomInput(
            "Contact Person",
            "text",
            "contact_person",
            "Enter Contact Person Name",
            {
              required: {
                value: true,
                message: "Please enter contact person name",
              },
            },
            errors
          )}
        </>
      )}

      {/* <=================Assigne=================> */}
      {fieldRoleMapping.selectDistributor.includes(role) &&
        !ownEdit &&
        mainRole == "super_admin" &&
        !isEditMode && (
          <CustomSelect
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            valueType="parent_id"
            label="Select Distributor"
            type="select"
            role="distributor"
            register={register}
            resetTrigger={resetTrigger}
            error={errors.parent_id}
            errorMessage="You need to select a distributor"
            placeholder="Select a Distributor"
          />
        )}
      {fieldRoleMapping.selectOffice.includes(role) &&
        !ownEdit &&
        mainRole !== "office" &&
        !isEditMode && (
          <CustomSelect
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            valueType="parent_id"
            label="Select Office"
            type="select"
            role="office"
            register={register}
            resetTrigger={resetTrigger}
            error={errors.parent_id}
            errorMessage="You need to select an office"
            placeholder="Select an office"
          />
        )}

      {fieldRoleMapping.selectAgent.includes(role) &&
        !ownEdit &&
        (mainRole == "super_admin" || mainRole == "distributor") &&
        !isEditMode && (
          <CustomSelect
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            valueType="parent_id"
            label="Select Agent"
            type="select"
            role="sales_agent"
            userRole={role}
            register={register}
            resetTrigger={resetTrigger}
            error={errors.parent_id}
            errorMessage="You need to select an Agent"
            placeholder="Select an agent"
          />
        )}
      {fieldRoleMapping.selectMonitoringStation.includes(role) &&
        !ownEdit &&
        mainRole !== "monitoring_station" &&
        mainRole !== "office" &&
        (mainRole === "super_admin" || mainRole === "sales_agent") &&
        !isEditMode && (
          <CustomSelect
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            valueType="parent_id"
            label="Select Monitoring Station"
            type="select"
            role="monitoring_station"
            register={register}
            resetTrigger={resetTrigger}
            error={errors.parent_id}
            errorMessage="You need to select a monitoring station"
            placeholder="Select a Monitoring Station"
          />
        )}
      {fieldRoleMapping.selectInstaller.includes(role) &&
        !ownEdit &&
        mainRole === "super_admin" &&
        !isEditMode && (
          <CustomSelect
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            valueType="installer_id"
            label="Select Installer"
            type="select"
            role="installer"
            register={register}
            resetTrigger={resetTrigger}
            error={errors.agent_id}
            errorMessage="You need to select an installer"
            placeholder="Select an Installer"
          />
        )}
      {/* <=================Location=================> */}
      {fieldRoleMapping.location.includes(role) && !ownEdit && !isEditMode && (
        <CustomSelect
          label="Location"
          type="select"
          clearErr={clearErrors}
          role="location"
          valueType="country_id"
          setValue={setValue}
          valueForEdit={item}
          register={register}
          resetTrigger={resetTrigger}
          error={errors.country_id}
          errorMessage="You need to select a Location"
          placeholder="Select Location"
        />
      )}

      {/* <=================Address=================> */}
      {fieldRoleMapping.address.includes(role) && (
        <>
          {renderCustomInput(
            "Address",
            "text",
            "address",
            "Enter Address",
            {
              required: {
                value: true,
                message: "Please enter address",
              },
            },
            errors
          )}
        </>
      )}

      {/* <=================Password=================> */}
      {!isEditMode && fieldRoleMapping.password.includes(role) && (
        <PasswordInput
          label="Password"
          placeholder="Enter Password"
          register={register("password", {
            required: "Password is required",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters",
            },
            validate: {
              hasNumber: (value) =>
                /[0-9]/.test(value) ||
                "Password must contain at least one number",
              hasUpperCase: (value) =>
                /[A-Z]/.test(value) ||
                "Password must contain at least one uppercase letter",
              hasSpecialChar: (value) =>
                /[!@#$%^&*]/.test(value) ||
                "Password must contain at least one special character",
            },
          })}
          error={errors.password}
        />
      )}

      {/* {!isEditMode && fieldRoleMapping.password.includes(role) && (
        <>
          {renderCustomInput(
            "Password",
            "password",
            "password",
            "Enter Password",
            {
              required: {
                value: true,
                message: "Please enter Password",
              },
            },
            errors
          )}
        </>
      )} */}
      {/* <====================== end of new portal V1 =================> */}

      {["Distributor", "Nursing Home"].includes(role) ? (
        renderCustomInput(
          `${getRoleLabel(role)} Name`,
          "text",
          "businessName",
          `Enter ${getRoleLabel(role)} Name`,
          {
            required: {
              value: true,
              message: `Please enter ${getRoleMessage(role)} Name`,
            },
          },
          errors
        )
      ) : [
          "office",
          "sales_agent",
          "nursing_home",
          "monitoring_station",
          "installer",
          "nurse",
          "supports_agent",
          "end_user",
          "super_admin",
          "distributor",
        ].includes(role) ? null : (
        <div className="flex items-center gap-4">
          {renderCustomInput(
            "First Name",
            "text",
            "firstName",
            "Enter First Name",
            {
              required: {
                value: true,
                message: "Please enter first name",
              },
            },
            errors
          )}
          {renderCustomInput(
            "Last Name",
            "text",
            "lastName",
            "Enter Last Name",
            {
              required: {
                value: true,
                message: "Please enter last name",
              },
            },
            errors
          )}
        </div>
      )}
      {["Office"].includes(role) && (
        <>
          {renderCustomInput(
            `${getRoleLabel(role)} Manager Name`,
            "text",
            "managerName",
            `Enter ${getRoleLabel(role)} Manager Name`,
            {
              required: {
                value: true,
                message: `Please enter ${getRoleMessage(role)} manager name`,
              },
            },
            errors
          )}
        </>
      )}
      {(role === "Nursing Home" || role === "Sales Agent") &&
        !["Distributor", "Sales Agent"].includes(loginRole) && (
          <CustomSelect
            setParentId={setParentId}
            label="Distributor"
            type="select"
            role="Distributor"
            clearErr={clearErrors}
            setValue={setValue}
            valueForEdit={item}
            register={register}
            error={errors.parentId}
            errorMessage="You need to select distributor"
            placeholder="Select Distributor"
          />
        )}

      {role === "Support Agent" && loginRole !== "Nursing Home" && (
        <CustomSelect
          setParentId={setParentId}
          clearErr={clearErrors}
          setValue={setValue}
          valueForEdit={item}
          label="Nursing Home"
          type="select"
          role="Nursing Home"
          register={register}
          error={errors.parentId}
          errorMessage="You need to select nursing home"
          placeholder="Select Nursing Home"
        />
      )}

      {/* Common Fields */}
      {[
        "Distributor",
        "Nursing Home",
        "Sales Agent",
        "End Users",
        "Super Admin",
        "Support Agent",
        "Nurse",
      ].includes(role) && (
        <div>
          {renderCustomInput(
            "E-mail",
            "email",
            "businessEmail",
            "Enter E-Mail",
            {
              required: {
                value: true,
                message: "Please enter E-mail",
              },
            },
            errors
          )}

          {isEmptyObject(item) &&
            renderCustomInput(
              "Password",
              "password",
              "password",
              "Enter Password",
              {
                required: {
                  value: true,
                  message: "Please enter Password",
                },
              },
              errors
            )}

          {[
            "Distributor",
            "Nursing Home",
            "Sales Agent",
            "End Users",
            "Support Agent",
            "Super Admin",
            "Office",
          ].includes(role) && (
            <>
              {renderCustomInput(
                "Address",
                "text",
                "businessAdress",
                "Enter Address",
                {
                  required: {
                    value: true,
                    message: "Please enter address",
                  },
                },
                errors
              )}
            </>
          )}

          {[
            "Distributor",
            "Nursing Home",
            "Sales Agent",
            "Office",
            "End Users",
            "Support Agent",
            "Super Admin",
            "Nurse",
          ].includes(role) && (
            <>
              {renderCustomInput(
                "Contact Number",
                "text",
                "contactNumber",
                "Enter Contact Number",
                {
                  required: {
                    value: true,
                    message: "Please enter contact number",
                  },
                },
                errors
              )}
            </>
          )}
          {["Sales Agent"].includes(role) && (
            <CustomSelect
              setParentId={setParentId}
              clearErr={clearErrors}
              setValue={setValue}
              valueForEdit={item}
              label="Select Office"
              type="select"
              role="Office"
              register={register}
              error={errors.parentId}
              errorMessage="You need to select an office"
              placeholder="Select an office"
            />
          )}
          {["Sales Agent"].includes(role) && (
            <>
              {renderCustomInput(
                `Location of Sales`,
                "text",
                "location",
                `Enter Sales Location`,
                {
                  required: {
                    value: true,
                    message: `Please enter sales location`,
                  },
                },
                errors
              )}
            </>
          )}
        </div>
      )}

      <DeleteModal
        onDelete={() => handalDelete()}
        modalOPen={deleteModal}
        setModalOpen={setDeleteModal}
        title={`Are you sure to delete this ${delRole} account? This`}
        title2=" process CAN’T be undone."
      />
    </CustomModal>
  );
};

export default CreateAndEditUsers;
